var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v14a2 2 0 002 2h4.305c.273 0 .445-.226.445-.475v-1.56c-2.493.553-3.023-1.235-3.023-1.235-.414-1.07-1-1.357-1-1.357-.82-.572.062-.553.062-.553.9.065 1.379.952 1.379.952.783 1.402 2.104.987 2.617.765.081-.6.317-1.006.569-1.236-1.998-.23-4.096-1.025-4.096-4.54 0-1.023.343-1.842.928-2.497-.09-.23-.406-1.19.09-2.436 0 0 .755-.25 2.474.94A8.286 8.286 0 0112 7.465c.765 0 1.539.1 2.25.303 1.719-1.19 2.475-.94 2.475-.94.495 1.245.18 2.205.09 2.436.584.655.927 1.474.927 2.498 0 3.523-2.106 4.298-4.113 4.529.324.286.621.85.621 1.707v2.527c0 .218.11.47.445.475H19a2 2 0 002-2V5a2 2 0 00-2-2H5z"
  })));
};

;
export default SvgGithub;